import { RATES_ZERO } from 'modules/product/views/components/product-offers/components/rates';

export function isProductRateZero(str: string): boolean {
    const lowerCase = str.toLowerCase();

    for (const text of RATES_ZERO) {
        if (lowerCase.includes(text.toLowerCase())) {
            return true;
        }
    }

    return false;
}
